import React, { useState } from "react";
import "./ReconnectBanner.css";

const ReconnectBanner = ({ onReconnect, onClose }) => {
  const [isReconnecting, setIsReconnecting] = useState(false);

  const handleReloadClick = async () => {
    setIsReconnecting(true);
    if (onReconnect) {
      await onReconnect();
    }
    // Note: Once connection succeeds, the Agora event listener will set remoteShow to false
    // and automatically unmount this component. If it fails or takes time, we allow clicking again after 5s.
    setTimeout(() => {
      setIsReconnecting(false);
    }, 5000);
  };

  return (
    <div className="reconnect-banner-container">
      <div className="reconnect-banner-content">
        <div className="reconnect-banner-icon-text">
          <span className="reconnect-banner-warning-icon" role="img" aria-label="warning">
            ⚠️
          </span>
          <div className="reconnect-banner-text-details">
            <h5 className="reconnect-banner-title">Dual Login Detected</h5>
            <p className="reconnect-banner-message">
              A concurrent login has been detected. As a result, your real-time chat connection has been lost, and you will not receive new messages or notification badges in real time. Please ensure you are logged out on other devices/tabs, and click <strong>'Reload'</strong> to re-establish your chat connection.
            </p>
          </div>
        </div>
        <div className="reconnect-banner-actions">
          <button
            className={`reconnect-banner-button ${isReconnecting ? "loading" : ""}`}
            onClick={handleReloadClick}
            disabled={isReconnecting}
          >
            {isReconnecting ? (
              <>
                <span className="reconnect-banner-spinner"></span>
                Reconnecting...
              </>
            ) : (
              "Reload"
            )}
          </button>
          <button
            className="reconnect-banner-close-btn"
            onClick={onClose}
            aria-label="Close warning"
          >
            &times;
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReconnectBanner;
